import { trackEvent } from '@otto-ec/nexus-registry/pdp/tracking';

export class CustomerReviewTextExpander {
    constructor() {}

    public init(rootElement: HTMLElement) {
        const reviewItemListIndex = this.extractReviewItemListIndex(rootElement);
        if (reviewItemListIndex === undefined) return;
        const selector = '.js_pdp_cr-item__expander';
        const expanderElement = rootElement.querySelector<HTMLOcExpanderV1Element>(selector);
        expanderElement?.addEventListener('oc-open', () => this.trackExpanderToggled(true, reviewItemListIndex));
        expanderElement?.addEventListener('oc-close', () => this.trackExpanderToggled(false, reviewItemListIndex));
    }

    private trackExpanderToggled(isOpen: boolean, reviewItemListIndex: number): void {
        trackEvent({
            review_SingleReviewText: [isOpen ? 'more' : 'less'],
            review_SingleReviewPosition: [String(reviewItemListIndex + 1)],
        });
    }

    private extractReviewItemListIndex(rootElement: HTMLElement): number | undefined {
        const { reviewItemListIndex } = rootElement.dataset;
        if (reviewItemListIndex === undefined) return;
        const parsedIndex = parseInt(reviewItemListIndex);
        return !isNaN(parsedIndex) ? parsedIndex : undefined;
    }
}
